export const routeMeta = {
  '/': {
    title: 'LEION Engineering | Weighbridge & Truck Scale Manufacturer',
    description: 'Weighbridges, truck scales and weighing software made in India and installed across Ghana and West Africa. ISO 9001 manufacturer since 2009. Request a quote.',
  },
  '/products': {
    title: 'Weighbridges, Indicators and Scales | LEION Engineering',
    description: 'Browse LEION pit type and pitless weighbridges, weigh in motion systems, weight indicators, table top scales and weighbridge software.',
  },
  '/products/weighbridges': {
    title: 'Pit and Pitless Weighbridges, Truck Scales | LEION',
    description: 'Compare LEION pit type, pitless and weigh in motion weighbridges. Supplied, installed and calibrated in India, Ghana and West Africa.',
  },
  '/products/indicators': {
    title: 'Weight Indicators for Weighbridges and Scales | LEION',
    description: 'HITECH Combi, IW01 and LE-K9 weight indicators for weighbridges and platform scales. Compare features and request pricing.',
  },
  '/products/table-top-scales': {
    title: 'Table Top Scales, BOSS Series | LEION Engineering',
    description: 'BOSS Series table top scales for counting, checking and retail weighing. Accurate, compact and supported by LEION service.',
  },
  '/products/software': {
    title: 'Weighbridge Software with ERP and RFID Integration | LEION',
    description: 'Weighbridge software that links weights to ERP, RFID, cameras and boom gates, with reports and tamper-proof records.',
  },
  '/products/p/pitless-weighbridge': {
    title: 'Pitless Weighbridge Manufacturer, India to Ghana | LEION',
    description: 'Above-ground steel weighbridge with ramps, so no pit or deep civil work is needed. Supplied, installed and calibrated by LEION in India and Ghana.',
  },
  '/products/p/pit-type-weighbridge': {
    title: 'Pit Type Weighbridge Manufacturer, India to Ghana | LEION',
    description: 'Flush-to-ground weighbridge for sites with limited approach space. Built by LEION, installed and calibrated in India, Ghana and West Africa.',
  },
  '/products/p/weigh-in-motion': {
    title: 'Weigh In Motion Truck Scale for Overload Checks | LEION',
    description: 'Weigh trucks without stopping them. LEION weigh in motion systems flag overloads at ports, mines and checkpoints. Talk to an engineer.',
  },
  '/products/p/hitech-combi-indicator': {
    title: 'HITECH Combi LE-07 Weight Indicator | LEION Engineering',
    description: 'HITECH Combi LE-07 digital weight indicator for weighbridges and industrial scales. Review features, specifications and request pricing from LEION.',
  },
  '/products/p/iw01-industrial-indicator': {
    title: 'IW01 Industrial Weight Indicator | LEION Engineering',
    description: 'IW01 industrial weight indicator for accurate weighing in demanding plant environments. View specifications and request a LEION quotation.',
  },
  '/products/p/le-k9-indicator': {
    title: 'LE-K9 Platform Scale Indicator | LEION Engineering',
    description: 'LE-K9 digital indicator for platform scales and everyday industrial weighing. Compare specifications and request support or pricing from LEION.',
  },
  '/products/p/boss-series-table-top': {
    title: 'BOSS Series Table Top Scale | LEION Engineering',
    description: 'Compact BOSS Series table top scale for everyday industrial and counter weighing. See specifications and request a quote.',
  },
  '/products/p/weighbridge-integration-software': {
    title: 'Weighbridge Integration Software, ERP, RFID | LEION',
    description: 'Connect your weighbridge to ERP, RFID readers, number plate cameras and gates. Automatic tickets and audit-ready reports.',
  },
  '/industries': {
    title: 'Weighbridges for Mining, Ports and Logistics | LEION',
    description: 'Weighing systems for mining, ports, logistics, agriculture and manufacturing, with installation and calibration in India and Ghana.',
  },
  '/about': {
    title: 'About LEION Engineering, Weighbridge Maker Since 2009',
    description: 'LEION Engineering has built weighbridges and weighing systems since 2009 in Gurgaon, India, serving customers across Ghana and West Africa.',
  },
  '/support': {
    title: 'Weighbridge Calibration, Repair and Service | LEION',
    description: 'On-site weighbridge calibration, repairs, spare parts and annual maintenance from LEION engineers in India and Ghana. Book a service visit.',
  },
  '/contact': {
    title: 'Contact LEION, Weighbridge Quotes for India and Ghana',
    description: 'Get a weighbridge quote or book service. Reach LEION Engineering teams in India and Ghana by phone, email or the enquiry form.',
  },
  '/privacy-policy': {
    title: 'Privacy Policy | LEION Engineering',
    description: 'Read how LEION Engineering collects, uses and protects personal information submitted through website enquiries and quote request forms.',
  },
  '/cookie-policy': {
    title: 'Cookie Policy | LEION Engineering',
    description: 'Learn how the LEION Engineering website uses browser storage and consent-based analytics, and how visitors can manage their preferences.',
  },
  '/terms-of-service': {
    title: 'Terms of Service | LEION Engineering',
    description: 'Review the terms that apply when using the LEION Engineering website, product information, enquiry forms and quotation services.',
  },
  '/leion-admin-insights': {
    title: 'Website Analytics | LEION Engineering',
    description: 'Private LEION Engineering website analytics dashboard for authorized administrators.',
    noindex: true,
  },
};

export const getRouteMeta = (pathname) => routeMeta[pathname] || {
  title: 'Page Not Found | LEION Engineering',
  description: 'The requested page could not be found. Browse LEION Engineering weighbridges, industrial scales, software and support services.',
  noindex: true,
};
